<template>
  <v-row justify="center" class="form-view-base">
    <v-col cols="12" class="pt-6">
      <div v-if="$slots.header" class="form-view-header mx-auto">
        <slot name="header"></slot>
      </div>
      <v-card
        :class="['form-view-card mx-auto', { 'pa-5': $mq !== 'xs' }]"
        :outlined="$mq !== 'xs'"
        elevation="0"
      >
        <slot name="title">
          <v-card-title v-if="title" class="justify-center">
            <h2>{{ title }}</h2>
          </v-card-title>
        </slot>
        <v-card-text>
          <v-form v-model="isFormValid" @submit.prevent="noop">
            <slot name="default" />
          </v-form>
        </v-card-text>
        <slot name="errors" />
        <slot name="actions" v-bind:valid="isFormValid" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FormViewBase',
  components: {},
  props: {
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isFormValid: false,
    }
  },
  methods: {
    noop() {},
  },
}
</script>

<style lang="css">
.form-view-card,
.form-view-header {
  max-width: 500px;
}

.form-view-base form.v-form input {
  font-size: 2em;
  line-height: 1.3 !important;
  max-height: none !important;
  font-weight: normal;
}
</style>
